import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { TOKEN_STORAGE } from "../auth/account.service";
import { AuthSSOProvider } from "../auth/sso-jwt.service";

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
  constructor(
    private localStorage: LocalStorageService,
    private sessionStorage: SessionStorageService,
    private authProvider: AuthSSOProvider
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      !request ||
      !request.url ||
      (request.url.startsWith("http") &&
        !(environment.apiURL && request.url.startsWith(environment.apiURL)))
    ) {
      return next.handle(request).pipe(
        catchError((err, caught) => {
          if (err.status === 401 || err.status === 403) {
            this.handleAuthError();
            return of(err);
          }
          throw err;
        })
      );
    }

    const token =
      this.localStorage.retrieve(TOKEN_STORAGE) ||
      this.sessionStorage.retrieve(TOKEN_STORAGE);

    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: "Bearer " + token,
        },
      });
    }

    return next.handle(request).pipe(
      catchError((err, caught) => {
        if (err.status === 401 || err.status === 403) {
          this.handleAuthError();
          return of(err);
        }
        throw err;
      })
    );
  }

  private handleAuthError() {
    this.localStorage.clear(TOKEN_STORAGE);
    this.sessionStorage.clear(TOKEN_STORAGE);
    this.authProvider.redirectoToSSO(environment.ssoURL, environment.ssoRealm);
  }
}
